
import React, {useState, useEffect} from 'react';

import {getItems} from './data';

import Lookup from "./Lookup";

import { useStateValue } from './state';

// import {QueryInput} from "./QueryInput";

const sortColor1 = 125;
const sortColor2 = 55; // 320

export const ItemsContainer = () => {

    const [{connection}, ] = useStateValue();
    const [{metadata}, ] = useStateValue();
    const [{operation}, dispatch] = useStateValue();

    const [items, setItems] = useState([]);

    // const KeySchema = metadata.Table.KeySchema;

    // let pkName = KeySchema[0].AttributeName;
    // let skName = KeySchema[1] ? KeySchema[1].AttributeName : null;
    //

    const t = metadata.Table;
    let target;

    if(operation.index) {
        const inx = t.GlobalSecondaryIndexes.filter(item => item.IndexName === operation.index);
        target = inx[0];

    } else {
        target = t;
    }

    const pkName = (target ? target.KeySchema[0].AttributeName : null);
    const skName = (target && target.KeySchema.length > 1 ? target.KeySchema[1].AttributeName : null);

    useEffect( () => {

        const fetchData = async () => {

            dispatch({type: 'appendLog', newMsg: operation.action + '()'});
            // console.log('********** ' + operation.LastEvaluatedKey);

            const data = await getItems(connection, operation, [pkName, skName], operation.LastEvaluatedKey);

            if(data && data.Items) {
                // console.log('data.Items:\n' +JSON.stringify(data.Items, null, 2));

                // dispatch({type: 'appendLog', newMsg: 'Scanned: ' + data.ScannedCount});
                dispatch({type: 'appendLog', newMsg: ' * Returned count: ' + data.Count});

                if(data.ConsumedCapacity) {
                    dispatch({type: 'appendLog', newMsg: ' * Consumed RCUs: ' + data.ConsumedCapacity.CapacityUnits});
                }

                if(data.LastEvaluatedKey) {
                    dispatch({type: 'appendLog', newMsg: 'More data remains, you left off at item: ' });
                    dispatch({type: 'appendLog', newMsg: JSON.stringify(data.LastEvaluatedKey) });
                    let op = operation;
                    op.LastEvaluatedKey = data.LastEvaluatedKey;
                    dispatch({"type":"setOperation", "operation": op});
                }

                setItems(data.Items.map(item => {
                        return item;
                    })
                );

            }
        };

        if(operation.action === 'query' && operation.pk === undefined) {
            // console.log('empty query form ready');

        } else {

            fetchData();
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[operation]);


    if (operation.action === 'scan') {

        return (<>
            <DataSetRenderer  metadata={metadata} data={items} operation={operation}  />

            </>
        );

    } else if (operation.action === 'query') {

        return(
            <div><Lookup />
                <DataSetRenderer  metadata={metadata} data={items} operation={operation}  />
            </div>);

    }
    else {
        return (null);
    }

};

const DataSetRenderer =  (props) => {

    const data = props.data;

    const metadata = props.metadata;

    const [{operation}, dispatch] = useStateValue();

    const t = metadata.Table;
    let target;

    if(operation.index) {
        const inx = t.GlobalSecondaryIndexes.filter(item => item.IndexName === operation.index);
        target = inx[0];

    } else {
        target = t;
    }

    const pk = (target ? target.KeySchema[0].AttributeName : null);
    const sk = (target && target.KeySchema.length > 1 ? target.KeySchema[1].AttributeName : null);

    let myCounter = 0;
    let partitionNumber = 0;
    let firstSK;


    const collapser = (event) => {
        let op = operation;
        op.collapse = !operation.collapse;

        dispatch({"type":"setOperation", "operation": op});

    };
    
    // operation.collapse=true;

    const SKlabel = () => {
        if(sk) {
            return (
                <>
                    {operation.collapse ? (<>
                        <td className='summaryLabel' ><b>{sk}</b> min</td>
                        <td className='summaryLabel' ><b>{sk}</b> max</td>
                    </>) : null}

                    <td className='summaryLabel'>
                        <b>{operation.collapse? 'Item Count': sk}</b>
                    </td>

                    <td className='summaryLabel' colSpan="3">
                        <label>
                            <input
                                name='collapser'
                                type='checkbox'
                                checked={operation.collapse ? true : false}
                                onChange={collapser} />
                            Collapse Partitions
                        </label>
                    </td>
                </>
            );
        } else {
            return null;
        }

    };

    // return (<h2>data here</h2>);
    return (
        <div>

            {/*<MainPanelHeader pk={pk} sk={sk} operation={operation} />*/}

            {(data.length === 0 && operation.action) ? (
                    <span className='summaryData'>
                        ...
                    </span>) :
                ['scan','query'].includes(operation.action) ?
                    (
                        <table className="dataTable">
                            <tbody>
                            <tr >
                                <td className='summaryLabel'><b>{pk}</b><br/>
                                </td>

                                <SKlabel/>

                                <td className='summaryLabel' colSpan="1000">
                                </td>
                            </tr>

                            {
                                data.map(
                                    (item, index, array) => {

                                        const currentRecordPK = array[index][pk];
                                        const previousRecordPK = array[index-1] ? array[index-1][pk] : true;
                                        const finalRecordPK = (array[index+1] && array[index][pk] === array[index+1][pk]) ? false : true;

                                        const newPartition = previousRecordPK && (previousRecordPK !== currentRecordPK);

                                        if(newPartition) {
                                            myCounter = 0;
                                            partitionNumber += 1;

                                            firstSK = item[sk] ? item[sk] : null;
                                            // console.log('item: \n' + JSON.stringify(item,null,2) );

                                            // console.log('set firstSK : ' + item[sk]);

                                        } else {
                                            myCounter += 1;
                                        }

                                        let className = (newPartition ? (sk ? 'rowTop' : 'row') : 'row');

                                        if(newPartition) {

                                            className = 'rowTop' ;
                                        }

                                        if(finalRecordPK && !newPartition) {
                                            className =  'rowBottom' ;
                                        }
                                        const ItemCountBar = (props) => {
                                            const barStyle = {
                                                backgroundColor:'pink',
                                                padding:4,
                                                width:10 + (10 * Math.log(props.count))
                                            };

                                            return (<div style={barStyle}>{props.count}</div>);
                                        };

                                        const lek = operation.LastEvaluatedKey || null;

                                        if(operation.collapse) {
                                            // const styleIdPrefix = operation.index ? '' : '';

                                            if(finalRecordPK) {

                                                const keyId = (operation.index ? 'index' : 'base') + partitionNumber%2;

                                                const r1 = {'backgroundColor': sortKeyGradient(1, operation.index ? sortColor2 : sortColor1)};
                                                let   r2 = {'backgroundColor': sortKeyGradient(2, operation.index ? sortColor2 : sortColor1)};

                                                if(lek && lek[pk] === item[pk]) {
                                                    r2.border = '2pt solid red';
                                                }

                                                const clickPK = () => {
                                                    const op = {action:"query",target:operation.target, index:operation.index, pk:currentRecordPK, sk: null };
                                                    dispatch({"type":"setOperation", "operation": op});
                                                };

                                                const clickSK = (e) => {
                                                    e.preventDefault();
                                                    let sk = e.target.getAttribute('value');
                                                    const op = {action:"query",target:operation.target, index:operation.index, pk:currentRecordPK, sk: sk };
                                                    dispatch({"type":"setOperation", "operation": op});
                                                };
                                                const scanMore = (e) => {
                                                    e.preventDefault();
                                                    // let lek = e.target.getAttribute('value');
                                                    const op = {action:"scan",target:operation.target, index:operation.index, LastEvaluatedKey:lek };
                                                    dispatch({"type":"setOperation", "operation": op});
                                                };

                                                return(<tr  key={index}>

                                                    <td id={keyId} className='pkSingle' >
                                                        <button className='partitionButton' onClick={clickPK}>{currentRecordPK}</button>

                                                    </td>

                                                        {firstSK ? (<td id='skMIN' style={r1} >

                                                            <button onClick={clickSK} value={firstSK} className='partitionButton'>{firstSK}</button>

                                                        </td>) : null}
                                                        {item[sk] ? (<td id='skMAX' style={r2} >

                                                            <button onClick={clickSK} value={item[sk]} className='partitionButton'>{item[sk]}</button>

                                                        </td>) : null}

                                                    <td className='attrValue' >
                                                        <ItemCountBar count={myCounter + 1} />

                                                    </td>
                                                    {/*{lek[pk] === item[pk] ? (*/}
                                                        {/*<td>*/}
                                                            {/*<button onClick={scanMore}>Scan from Here</button>*/}
                                                        {/*</td>*/}
                                                    {/*) : null}*/}

                                                </tr>);

                                            } else {
                                                return null;
                                            }

                                        } else {

                                            return(
                                                <tr key={index}  className={className} >

                                                    <RowRenderer
                                                        item={item}
                                                        newPartition={newPartition}
                                                        finalPartition={finalRecordPK}
                                                        metadata={metadata}
                                                        ks={target.KeySchema}
                                                        counter={myCounter}
                                                        partitionNumber={partitionNumber}
                                                    />
                                                </tr>
                                            )
                                        }


                                    }
                                )

                            }
                            </tbody>
                        </table>
                    ) : null
            }
        </div>
    );


};

const RowRenderer = (props) => {
    const [{operation}, dispatch] = useStateValue();

    const item = JSON.parse(JSON.stringify(props.item));
    const counter = props.counter;
    const partitionNumber = props.partitionNumber;
    const ks = props.ks;  // KeySchema

    const basePK = props.metadata.Table.KeySchema[0].AttributeName;
    const basePKvalue = item[basePK];


    let baseSK;
    let baseSKvalue;

    if(props.metadata.Table.KeySchema.length > 1) {
        baseSK = props.metadata.Table.KeySchema[1].AttributeName;
        baseSKvalue = item[baseSK];
    }

    const partitionKey = ks[0].AttributeName;

    const pkValue = item[partitionKey];
    delete item[partitionKey];

    let sortKey;
    let skValue;


    if(ks.length > 1) {
        sortKey = ks[1].AttributeName;
        skValue = item[sortKey];
        delete item[sortKey];
    }

    let pkClassName = 'partitionKey';

    if(props.newPartition && props.finalPartition) {
        pkClassName = 'pkSingle';
    } else {
        if(props.newPartition) {
            pkClassName = 'pkTop';
        }
        if(props.finalPartition) {
            pkClassName = 'pkBottom';
        }
    }



    const clickPK = () => {
        let op;
        if(operation.index) { // a GSI Query
            op = {action:"query",target:operation.target, index:operation.index, pk:pkValue, sk: null };

        } else { // base table

            if(sortKey) {
                op = {action:"query",target:operation.target, index:operation.index, pk:pkValue, sk: null };

            } else {
                op = {action:"get",target:operation.target, index:operation.index, pk:pkValue, sk:sortKey ? skValue : null };
            }
        }

        dispatch({"type":"setOperation", "operation": op});

    };

    const clickSK = () => {
        let op;

        if(operation.index) { // a GSI Query
            op = {action:"query",target:operation.target, index:operation.index, pk:pkValue, sk: sortKey ? skValue : null };

        } else {
            op = {action:"get",target:operation.target, index:operation.index, pk:pkValue, sk:sortKey ? skValue : null };

        }

       dispatch({"type":"setOperation", "operation": op});

    };

    const clickBasePK = () => {  // return to base table from GSI
        let op;

        if(operation.index) { // a GSI Query

            if(baseSK) {
                op = {action:"query",target:operation.target, index:null, pk:basePKvalue, sk: null };

            } else {
                op = {action:"get",target:operation.target, index:null, pk:basePKvalue, sk:null };
            }

            dispatch({"type":"setOperation", "operation": op});
        }

    };

    const clickBaseSK = () => {  // return to base table from GSI
        let op;

        if(operation.index) { // a GSI Query

            if(baseSK) {
                op = {action:"get",target:operation.target, index:null, pk:basePKvalue, sk: baseSKvalue };
                dispatch({"type":"setOperation", "operation": op});
            }

        }

    };

    let gsiLinkToItemPK;
    let gsiLinkToItemSK;

    if(operation.index) {

        gsiLinkToItemPK =
            (
                <td className='attrTD'>
                    <div className='attrLabel'>
                        {basePK}
                    </div>
                    <div className='attrValue'>
                        <button className='basePKbutton' onClick={clickBasePK} >{basePKvalue}</button>

                    </div>
                </td>
            );

        gsiLinkToItemSK = !baseSK ? null :
            (
                <td className='attrTD'>
                    <div className='attrLabel'>
                        {baseSK}
                    </div>
                    <div className='attrValue'>

                        <button className='baseSKbutton' onClick={clickBaseSK} >{baseSKvalue}</button>

                    </div>
                </td>
            );

        delete item[basePK];
        delete item[baseSK];

    }

    const attrMap = Object.keys(item);


    attrMap.sort((a,b) => {
        let ta = a;
        let tb = b;
        if(typeof item[a] === 'object') {ta = 'zzzzz';}  // force objs to end
        if(typeof item[b] === 'object') {tb = 'zzzzz';}
        return (tb > ta ? -1 : 1);
    });

    const stripe = partitionNumber % 2;
    const keyId = (operation.index ? 'index' : 'base') + stripe + ':' + partitionNumber + ':' + counter;

    const myStyle = {
        'backgroundColor': sortKeyGradient(counter, operation.index ? sortColor2 : sortColor1),
        'color':counter > 5 ? 'white' : 'dimgrey'
    };

    return(<>
            <td className={pkClassName} id={keyId} >

                <button className='partitionButton' onClick={clickPK} >
                    <div className='partitionButtonText'>
                        {pkValue}
                    </div>
                </button>
            </td>

            {sortKey ? (<td className='sortKey'  style={myStyle} id={'sort' + (operation.index ? 1 : 0 ) + '-' + keyId}>

                <button className='sortButton'  onClick={clickSK} >
                    {props.item[sortKey]}
                </button>

            </td>) : (null)}

            {gsiLinkToItemPK}
            {gsiLinkToItemSK}

                {attrMap.map((key) => {

                        // const ttlSummary = item[key];
                        const av = typeof item[key] === 'string' ? item[key] : JSON.stringify(item[key]);

                        const ttlSummary = 'timeto';

                        let valueDisplay = av;


                        if(key === basePK) {
                            valueDisplay = (<button className='basePKbutton' >{av}</button>);
                        }

                        if(key === baseSK) {
                            valueDisplay = (<button className='baseSKbutton' >{av}</button>);
                        }

                        return (<td key={key + '' + item[key]} className='attrTD'>
                                    <div className='attrLabel'>
                                        {key}
                                    </div>
                                    <div className='attrValue'>
                                        {valueDisplay }
                                    </div>
                                </td>);

                        }
                    )
                }


        </>
    );
};


const sortKeyGradient = (index, baseColor) => {
    // const baseColor = 115; // green
    const saturation = 100;
    const startingBrightness = 90;
    const stopAfter = 6;
    const stepSize = 9;

    return HSLToHex(baseColor, saturation, startingBrightness - ((index > stopAfter ? stopAfter : index) * stepSize));

};

const HSLToHex = (h,s,l) => {
    s /= 100;
    l /= 100;

    let c = (1 - Math.abs(2 * l - 1)) * s,
        x = c * (1 - Math.abs((h / 60) % 2 - 1)),
        m = l - c/2,
        r = 0,
        g = 0,
        b = 0;

    if (0 <= h && h < 60) {
        r = c; g = x; b = 0;
    } else if (60 <= h && h < 120) {
        r = x; g = c; b = 0;
    } else if (120 <= h && h < 180) {
        r = 0; g = c; b = x;
    } else if (180 <= h && h < 240) {
        r = 0; g = x; b = c;
    } else if (240 <= h && h < 300) {
        r = x; g = 0; b = c;
    } else if (300 <= h && h < 360) {
        r = c; g = 0; b = x;
    }
    // Having obtained RGB, convert channels to hex
    r = Math.round((r + m) * 255).toString(16);
    g = Math.round((g + m) * 255).toString(16);
    b = Math.round((b + m) * 255).toString(16);

    // Prepend 0s, if necessary
    if (r.length === 1)
        r = "0" + r;
    if (g.length === 1)
        g = "0" + g;
    if (b.length === 1)
        b = "0" + b;

    return "#" + r + g + b;
};
